import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "./App.css";
import CourseApplication from "./components/admin/CourseApplication";
import EachTrainee from "./components/admin/Eachtrainee";
import EachTrainer from "./components/admin/Eachtrainer";
import AdminEditCourse from "./components/admin/EditCourse";
import SponsorBudget from "./components/admin/sponsor/BudgetList";
import TraineesBulkUpload from "./components/admin/sponsor/BulkUploadTrainees";
import EachSponsor from "./components/admin/sponsor/EachSponsor";
import Flyer from "./components/Flyer";
import ForgotPassword from "./components/ForgotPassword";
import LandingPage from "./components/landingPage";
import EnrolmentSuccessful from "./components/trainee/enrolment/enrolmentSuccess";
import PaymentSuccessful from "./components/trainee/payments/PaymentSuccessful";
import FundWallet from "./components/trainee/wallet/FundWallet";
import PaymentSuccessfulWallet from "./components/trainee/wallet/PaymentSuccessful";
import MyTrainerCourses from "./components/trainer/courses/MyCourses";
import UploadResource from "./components/trainer/Resources/UploadResource";
import { AdminGuard } from "./guards/AdminGuard";
import { TraineeGuard } from "./guards/TraineeGuard";
import { TrainerGuard } from "./guards/TrainerGuard";
import AdminCalendar from "./pages/admin/Calendar";
import AdminCourses from "./pages/admin/courses/Courses";
import EachAdminCourse from "./pages/admin/courses/EachAdminCourse";
import AdminNewCourse from "./pages/admin/courses/NewCourse";
import AdminDashboard from "./pages/admin/Dashboard";
import AdminReview from "./pages/admin/PendingReview";
import ProgramCluster from "./pages/admin/programs/ProgramCluster";
import AdminReports from "./pages/admin/Reports";
import NewRole from "./pages/admin/roles/newRole";
import NewUser from "./pages/admin/roles/newUsers";
import Roles from "./pages/admin/roles/roles";
import UserRoles from "./pages/admin/roles/users";
import Adminroutes from "./pages/admin/routes";
import SponsorPayment from "./pages/admin/sponsor/Payment";
import SponsorDashboard from "./pages/admin/sponsor/SponsorDashboard";
import SponsorsList from "./pages/admin/sponsor/SponsorsList";
import CreateSurvey from "./pages/admin/survey/createSurvey";
import SingleSurvey from "./pages/admin/survey/singleSurvey";
import AdminSurvey from "./pages/admin/survey/Survey";
import SurveyTemplate from "./pages/admin/survey/surveyTemplates";
import UseTemplate from "./pages/admin/survey/useTemplate";
import ViewSurvey from "./pages/admin/survey/viewSurvey";
import AdminTrainees from "./pages/admin/Trainees";
import AdminTrainers from "./pages/admin/Trainers";
import AllCourses from "./pages/courses/AllCourses";
import courseRoutes from "./pages/courses/courseRoutes";
import EachCourse from "./pages/courses/EachCourse";
import DashboardAnnouncement from "./pages/dashboardAnnouncement";
import FAQ from "./pages/FAQ";
import HomeHelpdesk from "./pages/helpdesk/homeHelpdesk";
import NewRequest from "./pages/helpdesk/newRequest";
import PaymentGuidelines from "./pages/helpdesk/paymentGuidelines";
import TrackRequest from "./pages/helpdesk/trackRequest";
import Login from "./pages/login/Login";
import routes from "./pages/routes";
import TrackApplication from "./pages/trackApplication";
import Dashboard from "./pages/trainees/Dashboard";
import MyApplication from "./pages/trainees/MyApplication";
import MyCourse from "./pages/trainees/mycourses/MyCourse";
import MyCourses from "./pages/trainees/mycourses/MyCourses";
import Payment from "./pages/trainees/payments/Payment";
import PreRegistration from "./pages/trainees/register/PreRegistration";
import Register from "./pages/trainees/register/Register";
import VerifyEmail from "./pages/trainees/register/VerifyEmail";
import { InitialSurveyPage } from "./pages/trainees/survey/initialSurveyPage";
import Survey from "./pages/trainees/survey/Survey";
import AdvertisedCourses from "./pages/trainees/trainee-courses/AdvertisedCourses";
import Announcement from "./pages/trainees/trainee-courses/Announcement";
import AssignmentInfo from "./pages/trainees/trainee-courses/AnswerThoeryTrainee";
import Assignments from "./pages/trainees/trainee-courses/Assignments";
import AnswerQuiz from "./pages/trainees/trainee-courses/assignments/AnswerQuiz";
import CourseCalendar from "./pages/trainees/trainee-courses/Calendar";
import CheckResult from "./pages/trainees/trainee-courses/CheckResult";
import CourseInformation from "./pages/trainees/trainee-courses/CourseInformation";
import Discussions from "./pages/trainees/trainee-courses/Discussions";
import EachAnnouncement from "./pages/trainees/trainee-courses/EachAnnouncement";
import EachDiscussion from "./pages/trainees/trainee-courses/EachDiscussion";
import NewDiscussion from "./pages/trainees/trainee-courses/NewDiscussion";
import NewDiscussionGroup from "./pages/trainees/trainee-courses/NewDiscussionGroup";
import Resources from "./pages/trainees/trainee-courses/Resources";
import TrainerPreRegistration from "./pages/trainer/PreRegistration";
import TrainerRegister from "./pages/trainer/Profile";
import trainerRoutes from "./pages/trainer/routes";
import TrAnnouncement from "./pages/trainer/trainer-courses/Announcement";
import TrAssignment from "./pages/trainer/trainer-courses/assignments/AssignmentList";
import TrNewAssignment from "./pages/trainer/trainer-courses/assignments/NewAssignment";
import TrQuiz from "./pages/trainer/trainer-courses/assignments/Quiz";
import TrTheory from "./pages/trainer/trainer-courses/assignments/Theory";
import TrCourseCalendar from "./pages/trainer/trainer-courses/Calendar";
import TrCourseInformation from "./pages/trainer/trainer-courses/CourseInformation";
import TrDiscussions from "./pages/trainer/trainer-courses/Discussions";
import TrEachAnnouncement from "./pages/trainer/trainer-courses/EachAnnouncement";
import TrEachDiscussion from "./pages/trainer/trainer-courses/EachDiscussion";
import MyTrainees from "./pages/trainer/trainer-courses/MyTrainees";
import NewAnnouncement from "./pages/trainer/trainer-courses/NewAnnouncement";
import TrNewDiscussion from "./pages/trainer/trainer-courses/NewDiscussion";
import TrNewDiscussionGroup from "./pages/trainer/trainer-courses/NewDiscussionGroup";
import TrResources from "./pages/trainer/trainer-courses/Resources";
import TrainerResult from "./pages/trainer/trainer-courses/Result";
import TrainerDashboard from "./pages/trainer/trainerDashboard";
import TrainingCenters from "./pages/trainingCenters";
import UpcomingTrainings from "./pages/upcomingTrainings";

import AuditTrail from "./pages/admin/AuditTrail";
import DraftCourses from "./pages/admin/courses/DraftCourses";

import Alumni from "./pages/admin/roles/alumni";
import NewAlumni from "./pages/admin/roles/newAlumni";

import AdminResults from "./pages/admin/AdminResults";
import AdminDeferredAdmission from "./pages/admin/DeferredAdmissions";
import SessionTerms from "./pages/admin/SessionTerms";

import AdminShortlistedApplicants from "./pages/admin/ShortlistedApplicants";

import AdminProgramModules from "./pages/admin/programs/ProgramModules";
import AdminPrograms from "./pages/admin/programs/Programs";
import AdminProgramSettings from "./pages/admin/programs/ProgramSettings";

import AdminCreateProgram from "./components/admin/programs/CreateProgram";
import WalletHistory from "./components/trainee/wallet/WalletHistory";
import AssignedBadges from "./pages/admin/badges/AssignedBadges";
import Badges from "./pages/admin/badges/Badges";
import Centers from "./pages/admin/Center";
import AdminProgramDisciplineNSpecialization from "./pages/admin/programs/DisciplineAndSpecialization";
import Posting from "./pages/admin/programs/Posting";
import EditUser from "./pages/admin/roles/EditUsers";
import UserProfileHistory from "./pages/admin/UserProfileHistory";
import DuePayments from "./pages/trainees/payments/DuePayment";
import AnswerTheoryTrainee from "./pages/trainees/trainee-courses/AnswerThoeryTrainee";
import TrAttendanceList from "./pages/trainer/trainer-courses/AttendanceList";

import TrTheoryUpload from "./components/trainer/courses/assignments/Theory";
import AdminNewAnnouncement from "./pages/admin/announcements/AdminNewAnnouncement";
import AdminAnnouncements from "./pages/admin/announcements/Announcements";
import EditAnnouncement from "./pages/admin/announcements/EditAnnouncement";
import CourseTechnicality from "./pages/admin/courses/CourseTechnicality";
import AnnouncementDetail from "./pages/AnnouncementDetail";
import TrainingCalendar from "./pages/tainingCalendar";
import UpdateResult from "./pages/trainer/trainer-courses/UpdateResults";
import AdminTrainingCalendar from "./pages/admin/AdminTrainingCalendar";
import PendingVerification from "./pages/trainer/PendingVerification";
import DefermentSuccessful from "./components/trainee/enrolment/defermentSuccess";

function App() {
  return (
    <Router>
      <Routes>
        <Route path={routes.Flyer} element={<Flyer />} />
        <Route path={routes.LandingPage} element={<LandingPage />} />
        <Route path={routes.Registration} element={<Register />} />
        <Route path={routes.PaymentPath} element={<Payment />} />
        <Route path={routes.ForgotPassword} element={<ForgotPassword />} />
        <Route path={routes.Survey} element={<Survey />} />
        <Route path={routes.SurveyEntry} element={<InitialSurveyPage />} />
        <Route path={routes.Application} element={<MyApplication />} />
        <Route path={routes.PreRegistration} element={<PreRegistration />} />
        <Route path={routes.TrainingCalendar} element={<TrainingCalendar />} />
        <Route path={courseRoutes.ViewPath} element={<EachCourse />} />
        <Route path={courseRoutes.AllCourses} element={<AllCourses />} />
        <Route path={routes.VerifyEmail} element={<VerifyEmail />} />
        <Route
          path={routes.successfulPayment}
          element={<PaymentSuccessful />}
        />
        <Route
          path={routes.successfulPaymentWallet}
          element={<PaymentSuccessfulWallet />}
        />
        <Route path={routes.FundWallet} element={<FundWallet />} />
        <Route
          path={routes.successfulEnrolment}
          element={<EnrolmentSuccessful />}
        />
        <Route
          path={routes.successfulDeferment}
          element={<DefermentSuccessful />}
        />
        <Route path={routes.Login} element={<Login />} />
        <Route path={routes.Dashboard} element={<Dashboard />} />
        <Route
          path={Adminroutes.Dashboard}
          element={
            <AdminGuard>
              <AdminDashboard />
            </AdminGuard>
          }
        />
        <Route
          path={trainerRoutes.Dashboard}
          element={
            <TrainerGuard>
              <TrainerDashboard />
            </TrainerGuard>
          }
        />
        <Route
          path={routes.Dashboard}
          element={
            <TraineeGuard>
              <Dashboard />
            </TraineeGuard>
          }
        />
        <Route
          path={routes.trainerPreReg}
          element={<TrainerPreRegistration />}
        />
        <Route path={routes.UpcomingTraining} element={<UpcomingTrainings />} />
        <Route path={routes.TrackApplication} element={<TrackApplication />} />
        <Route path={routes.TrainingCenters} element={<TrainingCenters />} />
        <Route
          path={routes.DashboardAnnouncements}
          element={<DashboardAnnouncement />}
        />
        <Route
          path={routes.AnnouncementDetail}
          element={<AnnouncementDetail />}
        />
        <Route path={routes.FAQ} element={<FAQ />} />
        <Route path={routes.WalletHistory} element={<WalletHistory />} />
        <Route path={routes.HomeHelpdesk} element={<HomeHelpdesk />} />
        <Route path={routes.HelpdeskNewRequest} element={<NewRequest />} />
        <Route path={routes.HelpdeskTrackRequest} element={<TrackRequest />} />
        <Route
          path={routes.PendingVerification}
          element={<PendingVerification />}
        />
        <Route
          path={routes.PaymentGuidelines}
          element={<PaymentGuidelines />}
        />
        <Route
          path={trainerRoutes.trainerProfile}
          element={<TrainerRegister />}
        />
        <Route path={routes.Courses} element={<MyCourses />} />
        <Route path={routes.Result} element={<CheckResult />} />
        <Route path={courseRoutes.mycourse} element={<MyCourse />} />
        <Route path={courseRoutes.DuePayment} element={<DuePayments />} />
        <Route
          path={courseRoutes.CourseInformation}
          element={<CourseInformation />}
        />
        <Route path={courseRoutes.Announcement} element={<Announcement />} />
        <Route path={courseRoutes.Assignments} element={<Assignments />} />
        <Route path={courseRoutes.AssignmentQuiz} element={<AnswerQuiz />} />
        <Route
          path={courseRoutes.AssignmentTheory}
          element={<AnswerTheoryTrainee />}
        />
        <Route
          path={courseRoutes.AssignmentInfo}
          element={<AssignmentInfo />}
        />
        <Route path={courseRoutes.Calender} element={<CourseCalendar />} />
        <Route path={courseRoutes.Discussions} element={<Discussions />} />
        <Route path={courseRoutes.Resources} element={<Resources />} />
        <Route
          path={courseRoutes.EachDiscussion}
          element={<EachDiscussion />}
        />
        <Route
          path={courseRoutes.EachAnnouncement}
          element={<EachAnnouncement />}
        />
        <Route path={courseRoutes.NewDiscussion} element={<NewDiscussion />} />
        <Route
          path={courseRoutes.NewDiscussionGroup}
          element={<NewDiscussionGroup />}
        />
        <Route
          path={courseRoutes.advertisedCourses}
          element={<AdvertisedCourses />}
        />
        <Route
          path={trainerRoutes.trainerCourses.CourseInfo}
          element={<TrCourseInformation />}
        />
        <Route
          path={trainerRoutes.trainerCourses.mycourses}
          element={<MyTrainerCourses />}
        />
        <Route
          path={trainerRoutes.trainerCourses.Announcement}
          element={<TrAnnouncement />}
        />
        <Route
          path={trainerRoutes.trainerCourses.EachAnnouncement}
          element={<TrEachAnnouncement />}
        />
        <Route
          path={trainerRoutes.trainerCourses.Assignments}
          element={<TrAssignment />}
        />
        <Route
          path={trainerRoutes.trainerCourses.NewAssignment}
          element={<TrNewAssignment />}
        />
        <Route
          path={trainerRoutes.trainerCourses.Calendar}
          element={<TrCourseCalendar />}
        />
        <Route
          path={trainerRoutes.trainerCourses.Discussion}
          element={<TrDiscussions />}
        />
        <Route
          path={trainerRoutes.trainerCourses.Resources}
          element={<TrResources />}
        />
        <Route
          path={trainerRoutes.trainerCourses.UploadResources}
          element={<UploadResource />}
        />
        <Route
          path={trainerRoutes.trainerCourses.Trainees}
          element={<MyTrainees />}
        />
        <Route
          path={trainerRoutes.trainerCourses.AttendanceList}
          element={<TrAttendanceList />}
        />
        <Route
          path={trainerRoutes.trainerCourses.NewAnnouncement}
          element={<NewAnnouncement />}
        />
        <Route
          path={trainerRoutes.trainerCourses.EachDiscussion}
          element={<TrEachDiscussion />}
        />
        <Route
          path={trainerRoutes.trainerCourses.NewDiscussion}
          element={<TrNewDiscussion />}
        />
        <Route
          path={trainerRoutes.trainerCourses.NewDiscussionGroup}
          element={<TrNewDiscussionGroup />}
        />
        <Route
          path={trainerRoutes.trainerCourses.Result}
          element={<TrainerResult />}
        />
        <Route
          path={trainerRoutes.trainerCourses.UpdateResult}
          element={<UpdateResult />}
        />
        <Route path={trainerRoutes.trainerCourses.Quiz} element={<TrQuiz />} />
        <Route
          path={trainerRoutes.trainerCourses.Theory}
          element={<TrTheory />}
        />
        <Route
          path={trainerRoutes.trainerCourses.TheoryQuestions}
          element={<TrTheoryUpload />}
        />
        <Route path={Adminroutes.Report} element={<AdminReports />} />
        <Route path={Adminroutes.AuditTrails} element={<AuditTrail />} />
        <Route path={Adminroutes.Trainees} element={<AdminTrainees />} />
        <Route
          path={Adminroutes.ShortlistedApplicants}
          element={<AdminShortlistedApplicants />}
        />
        <Route path={Adminroutes.Sessions} element={<SessionTerms />} />
        <Route path={Adminroutes.Trainer} element={<AdminTrainers />} />
        <Route
          path={Adminroutes.DeferredAdmissions}
          element={<AdminDeferredAdmission />}
        />
        <Route path={Adminroutes.Calendar} element={<AdminCalendar />} />
        <Route path={Adminroutes.Courses} element={<AdminCourses />} />
        <Route
          path={Adminroutes.program_modules}
          element={<AdminProgramModules />}
        />
        <Route
          path={Adminroutes.DisciplineSpecialization}
          element={<AdminProgramDisciplineNSpecialization />}
        />
        <Route path={Adminroutes.Programs} element={<AdminPrograms />} />
        <Route
          path={Adminroutes.programSettings}
          element={<AdminProgramSettings />}
        />
        <Route path={Adminroutes.ManagePostings} element={<Posting />} />
        <Route path={Adminroutes.CourseDraft} element={<DraftCourses />} />
        <Route
          path={Adminroutes.CreateProgram}
          element={<AdminCreateProgram />}
        />
        <Route path={Adminroutes.ACourse} element={<EachAdminCourse />} />
        <Route path={Adminroutes.Survey} element={<AdminSurvey />} />
        <Route path={Adminroutes.Roles} element={<Roles />} />
        <Route path={Adminroutes.NewRole} element={<NewRole />} />
        <Route path={Adminroutes.UserRoles} element={<UserRoles />} />
        <Route path={Adminroutes.NewUser} element={<NewUser />} />
        <Route path={Adminroutes.EditUser} element={<EditUser />} />
        <Route path={Adminroutes.Alumni} element={<Alumni />} />
        <Route path={Adminroutes.NewAlumni} element={<NewAlumni />} />
        <Route path={Adminroutes.Badges} element={<Badges />} />
        <Route path={Adminroutes.Centers} element={<Centers />} />
        <Route path={Adminroutes.AssignedBadges} element={<AssignedBadges />} />
        <Route path={Adminroutes.CreateSurvey} element={<CreateSurvey />} />
        <Route path={Adminroutes.SingleSurvey} element={<SingleSurvey />} />
        <Route path={Adminroutes.Survey} element={<AdminSurvey />} />
        <Route path={Adminroutes.AdminResult} element={<AdminResults />} />
        <Route path={Adminroutes.SurveyTemplate} element={<SurveyTemplate />} />
        <Route path={Adminroutes.UseTemplate} element={<UseTemplate />} />
        <Route
          path={Adminroutes.UserProfileHistory}
          element={<UserProfileHistory />}
        />
        <Route path={Adminroutes.ViewSurvey} element={<ViewSurvey />} />
        <Route path={Adminroutes.Review} element={<AdminReview />} />
        <Route path={Adminroutes.NewCourse} element={<AdminNewCourse />} />
        <Route path={Adminroutes.EditCourse} element={<AdminEditCourse />} />
        <Route path={Adminroutes.ReviewTrainer} element={<EachTrainer />} />
        <Route path={Adminroutes.ReviewTrainee} element={<EachTrainee />} />
        <Route
          path={Adminroutes.ReviewApplication}
          element={<CourseApplication />}
        />
        <Route
          path={Adminroutes.sponsor.SponsorList}
          element={<SponsorsList />}
        />
        <Route
          path={Adminroutes.sponsor.SponsorDashboard}
          element={<SponsorDashboard />}
        />
        <Route
          path={Adminroutes.sponsor.EachSponsor}
          element={<EachSponsor />}
        />
        <Route
          path={Adminroutes.sponsor.UploadTrainees}
          element={<TraineesBulkUpload />}
        />
        <Route
          path={Adminroutes.sponsor.SponsorPayment}
          element={<SponsorPayment />}
        />
        <Route
          path={Adminroutes.sponsor.sponsorBudget}
          element={<SponsorBudget />}
        />
        <Route
          path={Adminroutes.ReviewTraineeCluster}
          element={<ProgramCluster />}
        />
        <Route
          path={Adminroutes.CourseTechnicality}
          element={<CourseTechnicality />}
        />
        <Route
          path={Adminroutes.AdminAnnouncements}
          element={<AdminAnnouncements />}
        />
        <Route
          path={Adminroutes.AdminNewAnnouncement}
          element={<AdminNewAnnouncement />}
        />
        <Route
          path={Adminroutes.EditAnnouncement}
          element={<EditAnnouncement />}
        />
        <Route
          path={Adminroutes.AdminTrainingCalendar}
          element={<AdminTrainingCalendar />}
        />
      </Routes>
    </Router>
  );
}

export default App;
